const DetailsCard = ({onEnquire}) => {
  return (
    <div className="bg-white w-[340px] rounded-2xl shadow-2xl overflow-hidden">
      <div className="bg-blue-800 text-white text-center py-2 text-sm">
        Bookings Open
      </div>

      <div className="p-5 text-center">
        <h2 className="text-xl font-bold">Siddha Sky Wadala</h2>
        <p className="text-sm text-gray-600">By Siddha Group</p>
        <p className="text-xs text-gray-500 mt-1">
          GTB Nagar Monorail Stn, Indira Nagar, Koliwada, Sion
        </p>

        <div className="mt-4 space-y-2 text-sm text-white">
          <div className="bg-[#6B7280] py-1 rounded">
            ◆ Land Parcel - 6.5 Acres
          </div>
          <div className="bg-[#6B7280] py-1 rounded">
            ◆ 2 BHK Jodi Option also available
          </div>
          <div className="bg-[#6B7280] py-1 rounded">
            ◆ Passession - Sep 2028
          </div>
        </div>

        <div className="mt-4">
          <p className="text-sm">Luxury 2, 3 & 4 BHK Skywalk Residence</p>
          <p className="text-2xl font-bold text-[#1E40AF]">
            ₹ 2.05 Cr* Onwards
          </p>
        </div>

        <button className="mt-4 w-full bg-[#090c6a] hover:bg-[#1218A6] text-white py-2 rounded-lg font-medium" onClick={onEnquire}>
          Enquire Now
        </button>
      </div>
    </div>
  );
};

export default DetailsCard;